import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import { SECTION_CARD } from '@/components/ui/section-card-variants'
import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'

/*
 * Market · Sectors before its first response: the LOADED board, block for
 * block (`4236:108727`): the turnover card and the sectors table. Every block
 * reuses the loaded component's own box classes (`SECTION_CARD`, DataTable's
 * head band and rows, the donut's 200px ring) so it matches at every width.
 * The table's row count is mm-be's usual eight sub-indices — typical, not
 * fixed. One block per legend key (the ring names five) and per table row,
 * never one per cell.
 *
 * Bars only, no words, so nothing here can be mistaken for the loaded
 * content. The page's own TitleRow is the exception, and ScreenLayout draws
 * it (see SectorsScreen).
 */

const SECTOR_ROWS = 8

/** Four named sectors and "Other sectors". */
const LEGEND_KEYS = 5

/** TurnoverShareCard: the head's title and hint, the 200px ring beside five legend keys, the note. */
function TurnoverShareSkeleton() {
  return (
    <div className={cn(SECTION_CARD, '@container [--section-card-pad-y:var(--space-5)]')}>
      <div className="flex min-h-6 items-center justify-between gap-3">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-3 w-40" />
      </div>
      <div className="mt-4 flex flex-col items-center gap-4 @xl:flex-row @xl:gap-10">
        <Skeleton className="size-50 shrink-0 rounded-full" />
        <div className="grid w-full min-w-0 flex-1 gap-x-5 @xl:grid-flow-col @xl:grid-cols-2 @xl:grid-rows-3">
          {Array.from({ length: LEGEND_KEYS }, (_, index) => (
            <div key={index} className="flex min-h-8 items-center">
              <Skeleton className="h-4 w-full max-w-60" />
            </div>
          ))}
        </div>
      </div>
      <Skeleton className="mt-3 h-3 w-2/3 max-w-lg" />
    </div>
  )
}

/** The turnover card and the table: what the screen draws while its data is in flight. */
export function SectorsBoardBody() {
  return (
    <>
      <TurnoverShareSkeleton />
      <DataTableSkeleton rows={SECTOR_ROWS} columns={8} />
    </>
  )
}
